<aside class="wrapper_assignment_panel">
  <div class="wrapper__assignment_panel__content">
    <h2 class="assignment-panel__title">Panel de asignaciones</h2>

    <div class="assignment-panel__content">
      <mat-tab-group [selectedIndex]="filters?.value?.confirmedDriver ? 1 : 0"
        (selectedIndexChange)="onTabChange($event === 0 ? 'unconfirmed' : 'confirmed')">
        <mat-tab label="Sin confirmar"></mat-tab>
        <mat-tab label="Confirmados"></mat-tab>
      </mat-tab-group>

      <div class="assignment-panel__filters row">
        <div class="col-12 col-md-6 col-lg-4 ">
          <mat-form-field appearance="outline" class="assignment-panel__filter-field">
            <mat-label>ID del servicio</mat-label>
            <input matInput [formControl]="filters.get('consecutive')" (keyup.enter)="resetPage()">
            <i matSuffix class="fas fa-search fa-lg color-primary cursor-pointer" matTooltip="Buscar servicio"
              (click)="resetPage()"></i>
          </mat-form-field>
        </div>

        <div class="col-12 col-md-6 col-lg-4 "
          *ngIf="availableDispatchStates?.length && !filters.get('confirmedDriver').value">
          <mat-form-field appearance="outline" class="assignment-panel__filter-field">
            <mat-label>Estado del despacho</mat-label>
            <mat-select [formControl]="filters.get('stateDispatch')" (selectionChange)="resetPage()">
              <mat-option value="">Todos</mat-option>
              <mat-option *ngFor="let dispatchState of availableDispatchStates" [value]="dispatchState.name">
                {{ dispatchState.name }}
              </mat-option>
              <mat-option value="pending">Pendiente de confirmación</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <app-select-company class=" col-12 col-md-6 col-lg-4" [options]="companyOptions"
          [inputFormControl]="filters.get('company')">
        </app-select-company>

        <app-autocomplete-city class="col-12 col-md-6 col-lg-4" [inputFormControl]="originControl"
          [options]="originOptions" [validate]="validateCityOrigin">
        </app-autocomplete-city>

        <div class="col-12 col-md-6 col-lg-4 ">
          <mat-form-field appearance="outline" class="date-field assignment-panel__filter-field">
            <mat-label>Desde</mat-label>
            <input matInput [matDatepicker]="pickerLoadDate" [formControl]="filters.get('dateLoad')"
              (click)="pickerLoadDate.open()" (dateChange)="resetPage()" readonly class="cursor-pointer">
            <mat-datepicker-toggle matPrefix [for]="pickerLoadDate"></mat-datepicker-toggle>
            <mat-datepicker #pickerLoadDate></mat-datepicker>
          </mat-form-field>
        </div>

        <div class="col-12 col-md-6 col-lg-4 ">
          <div class="assignment-panel__download-filter-actions">
            <mat-form-field appearance="outline"
              class="date-field assignment-panel__filter-field assignment-panel__download-filter-field">
              <mat-label>Hasta</mat-label>
              <input matInput [matDatepicker]="pickerDownloadDate" [formControl]="filters.get('endDate')"
                (click)="pickerDownloadDate.open()" (dateChange)="resetPage()" readonly class="cursor-pointer">
              <mat-datepicker-toggle matPrefix [for]="pickerDownloadDate"></mat-datepicker-toggle>
              <mat-datepicker #pickerDownloadDate></mat-datepicker>
            </mat-form-field>
          </div>
        </div>

        <div class="col-12 d-flex justify-content-end"
          [ngClass]="{'col-md-6 col-lg-4': !availableDispatchStates?.length || filters.get('confirmedDriver').value}">
          <button mat-raised-button class="primary-secondary assignment-panel__filter-action-button" color="primary"
            type="button" (click)="loadServices()" matTooltip="Recargar listado" title="Recargar listado">
            <i class="fas fa-sync-alt"></i>
          </button>
          <button mat-raised-button class="primary-secondary assignment-panel__filter-action-button" color="primary"
            type="button" (click)="cleanFilter()" title="Eliminar Filtros" matTooltip="Eliminar filtros">
            <i class="far fa-trash-alt"></i>
          </button>
        </div>
      </div>

      <div class="assignment-panel__table-container">
        <table mat-table [dataSource]="displayedRows" class="assignment-panel__table">
          <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef>ID</th>
            <td mat-cell *matCellDef="let item" class="cursor-pointer underline"
              (click)="utils.openCargoNewTab(item)">
              <span class="assignment-panel__consecutive">
                {{ item.consecutive || '-' }}
                <span class="assignment-panel__offers-badge" *ngIf="getVisualNumberOfOffers(item) as offersCount">
                  {{ offersCount }}
                </span>
              </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="contractor">
            <th mat-header-cell *matHeaderCellDef>Cliente</th>
            <td mat-cell *matCellDef="let item">
              {{ (item?.idCompany === item?.cargoOwner?.documentNumber)
              ? item?.cargoOwner?.name
              : (item?.idCompany ? (item?.idCompany | companyName) : '') }}</td>
          </ng-container>

          <ng-container matColumnDef="origin">
            <th mat-header-cell *matHeaderCellDef>Origen</th>
            <td mat-cell *matCellDef="let item">{{ item?.cargoFeature?.uploadDownload?.origin?.name || '-' }}</td>
          </ng-container>

          <ng-container matColumnDef="destination">
            <th mat-header-cell *matHeaderCellDef>Destino</th>
            <td mat-cell *matCellDef="let item">{{ getLastDestination(item)?.name || '-' }}</td>
          </ng-container>

          <ng-container matColumnDef="dateLoad">
            <th mat-header-cell *matHeaderCellDef>Cargue</th>
            <td mat-cell *matCellDef="let item">{{ item.dateLoad | dateFormat:'only-date' }}</td>
          </ng-container>

          <ng-container matColumnDef="dateDownload">
            <th mat-header-cell *matHeaderCellDef>Descargue</th>
            <td mat-cell *matCellDef="let item">
              {{ getLastDestination(item)?.downloadDate
              ? (getLastDestination(item)?.downloadDate | dateFormat:'only-date')
              : '-' }}</td>
          </ng-container>

          <ng-container matColumnDef="vehicle">
            <th mat-header-cell *matHeaderCellDef>Vehículo</th>
            <td mat-cell *matCellDef="let item">
              {{ !isTransportService(item) ? 'NO APLICA' : (item?.cargoFeature?.vehicleType?.name || '-') }}</td>
          </ng-container>

          <ng-container matColumnDef="bodyWorkType">
            <th mat-header-cell *matHeaderCellDef>Carrocería</th>
            <td mat-cell *matCellDef="let item">
              {{ !isTransportService(item) ? 'NO APLICA' : (item?.cargoFeature?.vehicleType?.bodyWorkType?.name || '-')
              }}</td>
          </ng-container>

          <ng-container matColumnDef="licensePlate">
            <th mat-header-cell *matHeaderCellDef>Placa</th>
            <td mat-cell *matCellDef="let item">
              {{ !isTransportService(item) ? 'NO APLICA' : (item?.licensePlate || '-') }}
              <i class="fas fa-info-circle color-secondary-dark cursor-pointer" *ngIf="getAssignmentFingerprint(item)"
                [matTooltip]="getAssignmentFingerprint(item)" matTooltipClass="tooltip__alert"></i>
            </td>
          </ng-container>

          <ng-container matColumnDef="dispatchState">
            <th mat-header-cell *matHeaderCellDef>Estado del despacho</th>
            <td mat-cell *matCellDef="let item">{{ !isTransportService(item) ? 'NO APLICA' : getDispatchState(item) }}
            </td>
          </ng-container>

          <ng-container matColumnDef="observations">
            <th mat-header-cell *matHeaderCellDef>Observaciones</th>
            <td mat-cell *matCellDef="let item"
              [ngClass]="{'underline cursor-pointer': item.stateDispatch?.observations}"
              [matTooltip]="item?.stateDispatch?.observations" matTooltipClass="tooltip__alert">{{
              item.stateDispatch?.observations? 'Ver observación' : '-' }}</td>
          </ng-container>

          <ng-container matColumnDef="state">
            <th mat-header-cell *matHeaderCellDef>Estado</th>
            <td mat-cell *matCellDef="let item">{{ getCargoState(item) }}</td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef class="assignment-panel__sticky-column">Acciones</th>
            <td mat-cell *matCellDef="let item" class="assignment-panel__sticky-column">
              <button mat-icon-button [matMenuTriggerFor]="rowActionsMenu" aria-label="Acciones"
                *ngIf="showActions(item)">
                <i class="fas fa-ellipsis-v"></i>
              </button>
              <mat-menu #rowActionsMenu="matMenu">
                <div [matTooltip]="canChangeDispatchState(item)?.message" matTooltipClass="tooltip__alert"
                  *ngIf="canChangeDispatchState(item)?.show">
                  <button mat-menu-item [disabled]="!canChangeDispatchState(item)?.can"
                    (click)="openChangeDispatchStateDialog(item)">
                    <i class="fas assignment-panel__action-icon"
                      [ngClass]="!canChangeDispatchState(item)?.can ? 'fa-info-circle assignment-panel__action-disabled-info' : 'fa-exchange-alt'"></i>
                    Cambiar estado del despacho
                  </button>
                </div>
                <div [matTooltip]="canEditDispatchObservation(item)?.message" matTooltipClass="tooltip__alert"
                  *ngIf="canEditDispatchObservation(item)?.show">
                  <button mat-menu-item [disabled]="!canEditDispatchObservation(item)?.can"
                    (click)="openEditDispatchObservationDialog(item)">
                    <i class="fas assignment-panel__action-icon"
                      [ngClass]="!canEditDispatchObservation(item)?.can ? 'fa-info-circle assignment-panel__action-disabled-info' : 'fa-edit'"></i>
                    Editar observación
                  </button>
                </div>
                <div [matTooltip]="canViewHistoryDispatchStateChanges(item)?.message" matTooltipClass="tooltip__alert"
                  *ngIf="canViewHistoryDispatchStateChanges(item)?.show">
                  <button mat-menu-item [disabled]="!canViewHistoryDispatchStateChanges(item)?.can"
                    (click)="openHistoryDispatchStateChanges(item)">
                    <i class="fas assignment-panel__action-icon"
                      [ngClass]="!canViewHistoryDispatchStateChanges(item)?.can ? 'fa-info-circle assignment-panel__action-disabled-info' : 'fa-history'"></i>
                    Ver historial de cambios
                  </button>
                </div>
                <div [matTooltip]="canOpenApplications(item)?.message" matTooltipClass="tooltip__alert"
                  *ngIf="canOpenApplications(item)?.show">
                  <button mat-menu-item class="has-applications-badge" [disabled]="!canOpenApplications(item)?.can"
                    (click)="openApplications(item.consecutive)">
                    <i class="fas assignment-panel__action-icon"
                      [ngClass]="!canOpenApplications(item)?.can ? 'fa-info-circle assignment-panel__action-disabled-info' : 'fa-search'"></i>
                    Buscar postulaciones
                    <div class="container-number" *ngIf="getVisualNumberOfOffers(item) as offersCount">
                      {{offersCount}}
                    </div>
                  </button>
                </div>
                <div [matTooltip]="canAssignVehicle(item)?.message" matTooltipClass="tooltip__alert"
                  *ngIf="canAssignVehicle(item)?.show">
                  <button mat-menu-item [disabled]="!canAssignVehicle(item)?.can"
                    (click)="openModalAssignVehicle(item)">
                    <i class="fas assignment-panel__action-icon"
                      [ngClass]="!canAssignVehicle(item)?.can ? 'fa-info-circle assignment-panel__action-disabled-info' : 'fa-truck'"></i>
                    Asignar vehículo
                  </button>
                </div>
                <div [matTooltip]="canConfirmVehicle(item)?.message" matTooltipClass="tooltip__alert"
                  *ngIf="canConfirmVehicle(item)?.show">
                  <button mat-menu-item [disabled]="!canConfirmVehicle(item)?.can"
                    (click)="openModalConfirmDriver(item)">
                    <i class="fas assignment-panel__action-icon"
                      [ngClass]="!canConfirmVehicle(item)?.can ? 'fa-info-circle assignment-panel__action-disabled-info' : 'fa-check-circle'"></i>
                    Confirmar placa
                  </button>
                </div>
                <div [matTooltip]="canDisassociateVehicle(item)?.message" matTooltipClass="tooltip__alert"
                  *ngIf="canDisassociateVehicle(item)?.show">
                  <button mat-menu-item [disabled]="!canDisassociateVehicle(item)?.can"
                    (click)="disassociateVehicle(item)">
                    <i class="fas assignment-panel__action-icon"
                      [ngClass]="!canDisassociateVehicle(item)?.can ? 'fa-info-circle assignment-panel__action-disabled-info' : 'fa-unlink'"></i>
                    Desasociar vehículo
                  </button>
                </div>
              </mat-menu>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
          <tr mat-row *matRowDef="let row; let odd = odd; columns: tableColumns"
            [ngClass]="{'assignment-panel__row--odd': odd}"></tr>
        </table>

        <div class="assignment-panel__empty" *ngIf="!displayedRows.length">
          {{ 'No hay resultados para los filtros aplicados.' }}
        </div>
      </div>

      <div class="assignment-panel__pagination">
        <button mat-button (click)="previousPage()" [disabled]="filters.get('pageKey').value === 1">Anterior</button>
        <small>Página {{ filters.get('pageKey').value }} | {{displayedRows.length}} de {{cargoCount}}</small>
        <button mat-button (click)="nextPage()"
          [disabled]="!displayedRows.length || filters.get('pageSize').value > displayedRows.length">Siguiente</button>

        <mat-form-field appearance="outline" class="assignment-panel__page-size">
          <mat-label>Mostrar</mat-label>
          <mat-select [value]="filters.get('pageSize').value" (selectionChange)="updatePageSize($event.value)">
            <mat-option *ngFor="let option of pageSizeOptions" [value]="option">{{ option }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </div>
</aside>